// Types
import { Selector } from 'react-redux';
import { HotTableStoreState, TableInstanceObject } from './hotTableStoreTypes';

export const getActiveTable: Selector<HotTableStoreState, TableInstanceObject | null> = (hotTableState) =>
    hotTableState.activeTable;
